import { snapDataUtils } from '#packages/util';

import type { Gap } from '../resizeGapsTypes';
import type { LayoutY } from '#packages/layout';

export function getSnapLineXPosition(gap: Gap): number {
  return gap.layout.x + gap.layout.width / 2 + gap.layout.width * 0.3;
}

export function getSnapLines(x: number, layoutY: LayoutY) {
  const xLineWidth = 5;

  const y1 = layoutY.y + 1;
  const y2 = layoutY.y + layoutY.height;
  const x1 = x - xLineWidth / 2;
  const x2 = x + xLineWidth / 2;

  return [
    snapDataUtils.getLine({ x, y: y1 }, { x, y: y2 }),
    snapDataUtils.getLine({ x: x1, y: y1 }, { x: x2, y: y1 }),
    snapDataUtils.getLine({ x: x1, y: y2 }, { x: x2, y: y2 }),
  ];
}
